/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  Typography,
  Input,
  Slider,
  withStyles,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(1.5),
  },
  constraintContainer: {
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "3px",
    marginBottom: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
  },
  inputValueBox: {
    display: "flex",
    flexDirection: "column",
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inputTitleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
  sliderInput: {
    maxWidth: "50px",
    "& > input": {
      textAlign: "center",
    },
    "&:before": {
      borderBottom: "none",
    },
    "&:first-child": {
      marginRight: "15px",
    },
    "&:last-child": {
      marginLeft: "15px",
    },
  },
  inputUnit: {
    color: "#929292",
    marginLeft: "5px",
    fontSize: "16px",
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
}));

const PrettoSlider = withStyles({
  root: {
    height: 8,
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -6,
    marginLeft: -10,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50%) -2px",
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  rail: {
    height: 6,
    borderRadius: 4,
  },
})(Slider);

const SliderComponent = ({
  inputData,
  constraints,
  handleTextInputChange,
  handleBlur,
  inputTexts,
  handleChange,
}) => {
  const classes = useStyles();
  return (
    <Box
      component="div"
      className={`${classes.constraintContainer} ${classes.padding}`}
    >
      <Box component="div" className={classes.inputTitleBox}>
        <Typography variant="body2" className={classes.alignCenterFlex}>
          <b>{inputData.label}</b>
          <Box component="span" className={classes.inputUnit}>
            {inputData.unit}
          </Box>
        </Typography>
      </Box>
      <Box component="div" className={classes.inputValueBox}>
        {/* <Typography variant="body2">{inputData.description}</Typography> */}
        <Box component="div" className={classes.sliderContainer}>
          <Input
            className={classes.sliderInput}
            value={inputTexts[inputData.key][0]}
            margin="dense"
            onChange={(ev) =>
              handleTextInputChange(inputData.key, [
                !ev.target.value ? "" : ev.target.value,
                inputTexts[inputData.key][1],
              ])
            }
            onBlur={() => handleBlur(inputData.key, 0)}
            inputProps={{
              step: 1,
              min: inputData.minValue,
              max: inputData.maxValue,
              type: "text",
              "aria-labelledby": "input-slider",
            }}
          />
          <PrettoSlider
            value={constraints[inputData.key]}
            onChange={(ev, value) => handleChange(inputData.key, value)}
            valueLabelDisplay="auto"
            name={inputData.key}
            aria-labelledby="range-slider"
            min={inputData.minValue}
            max={inputData.maxValue}
          />
          <Input
            className={classes.sliderInput}
            value={inputTexts[inputData.key][1]}
            margin="dense"
            onChange={(ev) =>
              handleTextInputChange(inputData.key, [
                inputTexts[inputData.key][0],
                !ev.target.value ? "" : ev.target.value,
              ])
            }
            onBlur={() => handleBlur(inputData.key, 1)}
            inputProps={{
              step: 1,
              min: inputData.minValue,
              max: inputData.maxValue,
              "aria-labelledby": "input-slider",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SliderComponent;
